import type { ChargeSheetItemSection, InvoiceLineItem } from '~/types'

import { getIsRetailOrderLineItem } from '../invoices/invoiceUtils'

export const calculateSelectedWplanDiscount = (
  chargeSheetItems: ChargeSheetItemSection[],
) =>
  chargeSheetItems
    .map((item) => item.groupedItems)
    .flat()
    .reduce((prev, groupedItem) => {
      if (getIsRetailOrderLineItem(groupedItem)) {
        return prev
      }

      const items =
        Array.isArray(groupedItem.items) && groupedItem.items.length > 0
          ? groupedItem.items
          : [groupedItem]
      const groupWplanDiscount = items.reduce((sum, item: InvoiceLineItem) => {
        if (item?.wplanCharged === false) {
          const discountValue = Number(item.discount ?? 0)
          return sum + (Number.isFinite(discountValue) ? discountValue : 0)
        }
        return sum
      }, 0)

      return prev + groupWplanDiscount
    }, 0)
